import React from 'react'
import TopNav from '../components/TopNav'
import GmaBanner from '../components/GmaBanner'
import Footer from '../components/Footer'
const EducationPage: React.FC = () => {
    return (
        <>
            <TopNav />
            <div className="container-fluid w-100 h-auto m-0 p-0">
                <img
                    src="./img/kids/yhds.jpeg"
                    className="img-fluid w-100 pt-4 mt-5 top-image"
                    alt="Young History Detectives educational program"
                    style={{ height: '50%' }}
                />
            </div>
            <section className="" id="services" style={{ padding: 0 }}>
                <div className="container-fluid" style={{ padding: 0, margin: 0 }}>
                    <div className="row" style={{ padding: 0, margin: 0 }}>
                        <div className="col" style={{ padding: 0, margin: 0 }}>
                            <div className="text-center" style={{ backgroundColor: '#908068', color: 'black' }}>
                                <h1 className="text-uppercase py-1 subheading">Education</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container my-5">
                    <div className="row">
                        <div className="col">
                            <div className="text-center">
                                <h3 className="section-subheading text-muted">
                                    Businesses and fellow foundations have given their time and support to help us make a difference in children&apos;s lives.
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col"></div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div className="text-center mt-5 yhd">
                                <h2>2025 Summer Camp Season for Young History Detectives</h2>
                                <h4>YHD Summer Registration is now open!</h4>
                                <div className="my-5">
                                    <a href="https://m4k691fqe81.typeform.com/to/bF4hKTC8" className="btn btn-lg  btn-success">
                                        Click to Register
                                    </a>
                                </div>
                                <p>
                                    YHD participants learn research skills, history, and oral storytelling. Oral Histories preserve community history uniquely.
                                    We explore storytelling through art, music, dance, gaming, creative writing, illustration, yoga, meditation, sound therapy,
                                    and photography.
                                </p>
                                <p>
                                    Each day blends calm and creativity—with daily yoga, mindfulness, and journaling to start us off right. Art, games, and fun
                                    are built into our routine, along with exciting trips to UNO’s Wellness Center for swimming or rock climbing. We’ll also
                                    explore Omaha through tours, visit the Durham History Museum and historic landmarks, connect with inspiring community
                                    leaders, and dive into the rich stories that bring our city to life!
                                </p>
                                <h4>2025 Summer Camps</h4>
                            </div>
                        </div>
                    </div>

                    <div className="row yhd ">
                        <div className="col d-flex justify-content-center mt-2">
                            <p>
                                <strong>Junior Camp (ages 9-11)</strong>
                                <br />
                                July 21-July 25, 2025
                                <br />
                                10:00 AM-5:00 PM
                            </p>
                        </div>
                        <div className="col d-flex justify-content-center mt-2">
                            <p>
                                <strong>YHD Camp (12-18)</strong>
                                <br />
                                July 28-August 8<br />
                                10:00 AM-5:00 PM
                            </p>
                        </div>
                    </div>
                    <div className="my-3 text-center">
                        <a href="https://m4k691fqe81.typeform.com/to/bF4hKTC8" className="btn btn-lg btn-success">
                            Click to Register
                        </a>
                    </div>
                    <div className="text-center mt-5">
                        <h2>Pictures from our Events</h2>
                    </div>

                    <div className="container mt-5">
                        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-3">
                            <div className="col">
                                <img src="./img/education/edimg1.jpeg" alt="edimg1.jpeg" className="img-fluid" />
                            </div>
                            <div className="col">
                                <img src="./img/education/edimg2.jpeg" alt="edimg2.jpeg" className="img-fluid" />
                            </div>
                            <div className="col">
                                <img src="./img/education/edimg3.jpeg" alt="edimg3.jpeg" className="img-fluid" />
                            </div>
                            <div className="col">
                                <img src="./img/education/edimg4.jpeg" alt="edimg4.jpeg" className="img-fluid" />
                            </div>
                            <div className="col">
                                <img src="./img/education/edimg5.jpeg" alt="edimg5.jpeg" className="img-fluid" />
                            </div>
                            <div className="col">
                                <img src="./img/education/edimg6.jpg" alt="edimg6.jpg" className="img-fluid" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="row">
                <div className="col">
                    <GmaBanner />
                </div>
            </div>

            <Footer />
        </>
    )
}

export default EducationPage
